module.exports = __webpack_public_path__ + "/static/assets/5f48dbcc5cae7298c908ae40bf9d36ad.png";